import { DropdownInputField, DropdownInputOptions, IFormField, IFormSection } from "../../../../../shared/components/web-form/web-form.objects";
import _ from "lodash";

export class RequestHistoryField implements IFormField {
    fieldId: string;
    displayName: string;
    isRequired: boolean;
    propertyName: string;
    defaultVal: any;
    formSection: IFormSection;
    controllingDropdownSelector: string;
    triggerValue: string;
    containerSelector: string;
    options: DropdownInputOptions;
    forObjProperty: boolean = true; 
    shouldTriggerUpdate: boolean = false;

    constructor(
        propertyName: string,
        defaultVal: any,
        fieldId: string,
        displayName: string,
        isRequired: boolean,
        options: DropdownInputOptions,
        controllingDropdownSelector: string,
        triggerValue: string,
        containerSelector: string
    ) {
        this.propertyName = propertyName;
        this.defaultVal = defaultVal;
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.isRequired = isRequired;
        this.options = options;
        this.controllingDropdownSelector = controllingDropdownSelector;
        this.triggerValue = triggerValue;
        this.containerSelector = containerSelector;
    }

    initialize(formSection: IFormSection) {
        this.formSection = formSection;
        this.populateDropdown();
        // Listen for changes on the controlling dropdown
        $(this.controllingDropdownSelector).on("changed.bs.select change", () => {
            this.toggleVisibility();
            this.triggerSectionUpdate();
        });

        $(`#${this.fieldId}`).on("changed.bs.select change", () => {
            this.triggerSectionUpdate();
        });

        // Initialize visibility
        this.toggleVisibility();
    }

    private toggleVisibility() {
        const dropdownValue = String($(this.controllingDropdownSelector).val());

        if (dropdownValue === this.triggerValue) {
            $(this.containerSelector).removeClass("d-none");
            this.isRequired = true;
        } else {
            $(this.containerSelector).addClass("d-none");
            $(`#${this.fieldId}`).selectpicker("val", "");
            $(`#${this.fieldId}`).selectpicker("refresh");
            this.isRequired = false;
            this.resetValidDisplay();
        }
    }

    private getInputValue(): any {
        return $(`#${this.fieldId}`).val();
    }

    getValue(): any {
        const val = this.getInputValue();

        if (!this.checkValid()) {
            return this.defaultVal;
        }

        return val ? Number(val) : this.defaultVal;
    }

    setValue(formData: any) {
        const value = _.get(formData, this.propertyName);

        if (value !== undefined && value !== null) {
            $(`#${this.fieldId}`).val(String(value));
            $(`#${this.fieldId}`).selectpicker?.("refresh");
        }

        this.toggleVisibility();
    }

    checkValid(): boolean {
        const dropdownValue = String($(this.controllingDropdownSelector).val());
        const inputValue = String(this.getInputValue());

        if (dropdownValue === this.triggerValue) {
            return inputValue !== "0" && inputValue !== "" && inputValue !== "null" && inputValue !== "undefined";
        }

        return true;
    }

    checkChanged(): boolean {
        return this.getInputValue() !== this.defaultVal;
    }

    displayValid(isValid: boolean) {
        $(`#${this.fieldId}`)
            .toggleClass("is-valid", isValid)
            .toggleClass("is-invalid", !isValid);
    }

    resetValidDisplay() {
        $(`#${this.fieldId}`).removeClass("is-valid is-invalid");
    }

    triggerSectionUpdate() {
        if (this.formSection && this.shouldTriggerUpdate) {
            this.formSection.updateSection();
        }
    }

    private populateDropdown() {
        const dropdown = $(`#${this.fieldId}`);

        dropdown.empty();

        $(`#${this.fieldId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count"
        });

        dropdown.append(`<option hidden disabled selected value>-- Select --</option>`);

        this.options.options.forEach(option => {
            dropdown.append(new Option(option.Value, option.Id.toString(), false, false));
        });

        dropdown.selectpicker("refresh");
    }
}
